<template>
  <b-row>
    <b-col cols="12" class="d-flex overflow-x-auto m-3 b-col-overflow" style="align-items: flex-start; scrollbar-width: thin">
      <b-card v-for="column in columns" :key="column['@id']" class="mr-4 card-kanban mb-3">
        <div class="mb-0 pb-2 pt-0 mt-0 mr-1 card-kanban-header">
          <button v-if="ableToAddOrganizationLead" type="button" @click="showModal(column['@id'])"  class="float-right btn btn-link"><i class="fa fa-plus"></i></button>
          <h4 class="ml-2 mt-2 mb-0" style="font-size: 16px;color: #1976d2">{{ column.title }}</h4>
          <h4 class="ml-2 mt-0 mb-0" style="font-size: 12px">{{$t('views.exaborganizationlead.list.leadCounterStatus')}}: <span>{{column.organizationLeads.length}}</span></h4>
        </div>
        <draggable tag="div" @change="handleDrag" :list="column.organizationLeads" :animation="400" ghost-class="ghost-card" group="organizationLeads" class="pr-1 pl-1">
          <organization-lead-card
            v-for="organizationLead in column.organizationLeads"
            :key="organizationLead['@id']"
            :organizationLead="organizationLead"
            style="cursor: all-scroll"
            :fetch-data="fetchOrganizationsLeadsKanbanBoard"
            :add-note-to-organization-lead-modal="addNoteToOrganizationLeadModal"
            :add-phone-to-organization-lead-modal="addPhoneToOrganizationLeadModal"
            :add-meeting-to-organization-lead-modal="addMeetingToOrganizationLeadModal"
          ></organization-lead-card>
        </draggable>
      </b-card>
    </b-col>
    <OrganizationLeadCreateModal :id-status="idStatusForCreateLead"></OrganizationLeadCreateModal>
  </b-row>
</template>

<script>
import ApiService from '@/utils/ApiService'
import draggable from 'vuedraggable'
import OrganizationLeadCard from '@/components/Dashboard/Views/AgreementsBundle/exaborganizationlead/components/organizationLeadCard.vue'
import OrganizationLeadCreateModal from '@/components/Dashboard/Views/AgreementsBundle/exaborganizationlead/modals/OrganizationLeadCreateModal.vue'
import { mapGetters, mapMutations } from 'vuex'
import { checkPermission } from '@/utils/checkRoles'

export default {
  name: 'OrganizationLeadKanbanBoard',
  components: {
    OrganizationLeadCreateModal,
    draggable,
    OrganizationLeadCard
  },
  props: {
    addNoteToOrganizationLeadModal: {
      type: Function,
      required: false,
      default: () => {}
    },
    addPhoneToOrganizationLeadModal: {
      type: Function,
      required: false,
      default: () => {}
    },
    addMeetingToOrganizationLeadModal: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      columns: [],
      columnsReference: [],
      idStatusForCreateLead: null
    }
  },
  computed: {
    ableToAddOrganizationLead () {
      return checkPermission('firms', 'EXABOrganizationLeadCreate')
    },
    ...mapGetters({
      created: 'exaborganizationlead/create/created'
    })
  },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.fetchOrganizationsLeadsKanbanBoard()
    }
  },
  created () {
    this.fetchOrganizationsLeadsKanbanBoard()
  },
  methods: {
    async fetchOrganizationsLeadsKanbanBoard () {
      this.columns = await new ApiService('e_x_a_b_organization_leads_kanbanboard').getResults()
      this.columnsReference = JSON.parse(JSON.stringify(this.columns))
    },
    handleDrag (event) {
      if (event.added) {
        const newLeadStatus = event.added.element
        const newIdCustomStatus = this.columns.find(column =>
          column.organizationLeads.some(organizationLead => organizationLead['@id'] === newLeadStatus['@id']))['@id']
        this.changeLeadStatus(newLeadStatus, newIdCustomStatus)
      }
    },
    showModal (idStatus) {
      this.idStatusForCreateLead = idStatus
      this.toggleModal()
    },
    async changeLeadStatus (newLeadStatus, newIdCustomStatus) {
      let params = { idStatus: newIdCustomStatus }
      await new ApiService(newLeadStatus['@id']).putSilent(params)
    },
    ...mapMutations({
      toggleModal: 'exaborganizationlead/createModal/toggleModal'
    })
  }
}
</script>
